export default __webpack_public_path__ + "static/media/image-auth-icon.8bc83079.svg";